<style lang="stylus">
.loginmodalwrap
  // width: 550px !important
  width: 400px !important
  border-radius 5px
  .loginwrap
    padding: 14px 30px 0
    .loginlogo
      text-align: center
      img
        width: 160px
    .logintiptitle
      position: relative
      text-align: center
      color: #bbb
      font-size: 16px
      margin: 16px 0 15px
      div
        position: absolute
        top: 50%
        left: 50%
        right: 0
        height: 1px
        background: #eee
        margin-top: -1px
        transform: translateX(-50%)
      span
        position: relative
        padding: 0 30px
        background: #fff
        color #737373
        font-size 16px
    .notetipwrap_amend
      line-height:30px
      text-align:right
    .verifycodeimgwrap
      display: block
      width: 100%
      height: 40px
      cursor: pointer
      img
        width: 100%
        height: 100%
        display: block
    .verifycodebtn
      /* background: #fff
      &:active, &:focus
        color: #409EFF
      &:hover
        background: #409EFF
        color: #fff !important */
    .regreadxieyi
      .el-checkbox__label
        font-size: 12px
</style>

<template>
  <div>
    <el-dialog
      :visible.sync="outsideLoginModal"
      @close="modalClose"
      :close-on-click-modal="false"
      custom-class="loginmodalwrap">
      <div class="loginwrap">
        <div class="loginlogo">
          <img src="/static/icon/logo2.png">
        </div>

        <!-- type=note,验证码登录 -->
        <div v-if="type == 'note'" class="notetapwrap" key="notetapwrap">
          <div class="logintiptitle">
            <div style="width: 251px;"></div>
            <span>授权咨询</span>
          </div>
          <el-form :model="noteform" :rules="noteRules" ref="noteform">
            <el-form-item prop="account">
              <el-input v-model.trim="noteform.account" @keyup.enter.native="NoteSubmitForm('noteform')" size="medium" placeholder="手机号码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-row>
                <el-col :span="14">
                  <el-form-item prop="verifycode">
                    <el-input v-model.trim="noteform.verifycode" @keyup.enter.native="NoteSubmitForm('noteform')" class="ipt verifycode" placeholder="输入验证码"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="9" :offset="1">
                  <el-button v-if="!noteform.starttime" @click.stop="notegetcode" type="primary" plain class="verifycodebtn">获取验证码</el-button>
                  <el-button v-else type="primary" plain class="verifycodebtn" long disabled>{{noteform.runtime}}秒后重发</el-button>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item>
              <el-button @click="NoteSubmitForm('noteform')" :loading="loginnings" type="primary" style="width: 100%;margin:30px 0px;">授权登录咨询</el-button>
            </el-form-item>
          </el-form>

        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {createRandom} from '@/common/js/createRandom';
import sockets from '@/socket';

export default {
  name: 'outsideLogin',
  data() {
    return {
      outsideLoginModal:true,
      type: 'note',   // login reg cpwd
      imgCacheText: createRandom(),
      noteform:{
        account:'',
        verifycode:'',
        accounttype:'',
        againtime: 60,
        runtime: 60,
        starttime: false
      },  //短信验证登录
      noteRules:{
        account: [
          { required: true, message: '手机号', trigger: 'blur' },
        ],
        verifycode: [
          { required: true, min: 4, max: 6, message: '验证码错误', trigger: 'blur' }
        ]
      },
      loginnings: false
    }
  },
  props:{
    outsidePhone:{
      type:String,
      default() {
          return '';
      }
    }
  },
  computed: {
    OutsideloginStatus() {
      return this.$store.state.OutsideloginStatus;
    }
  },
  beforeMount() {
    this.outsideLoginModal = this.OutsideloginStatus.display;
    // 账号封禁
    if (this.$route.query.errmsg == '1') {
      this.$alert('您已经被禁止登陆！', '登陆错误提示', {
        confirmButtonText: '确定',
        type: 'error',
        callback: action => {
          if( action == 'confirm' ){
            window.location.replace(window.location.href.split('?')[0]);
          }
        }
      });
    }
  },
  methods: {
    modalClose() {
      this.$store.commit('changeOutsideLoginStatus', {display: false,type:0});
    },
    notegetcode(){
      this.starttime('noteform');
      let url = 'Ucenter/getsms'
      let param = { phone: this.noteform.account }


      this.$http.post(url, param).then(response => {
        if( response.data.retcode == $conf.RETCODE_OK ){
          this.$message.success( '获取验证码成功，请查收！' );
        }else{
          this.registerform.runtime = 0;
          this.$message.error( response.data.errmsg );
        }
      }).catch(err => {
        if( err.response ) {
          switch( err.response.status ) {
            case 429:
              this.$message.error( '发送验证码太频繁，请稍后重试！' );
          }
        }
      });
      
    },
    NoteSubmitForm(formName){  //Ucenter/consultAuth登录授权咨询  phone手机, code验证码
      if( this.loginnings ){
        return;
      }
      this.$refs[formName].validate((valid) => {
        if( valid ){
          this.loginnings = true;
          let param = { phone: this.noteform.account , code: this.noteform.verifycode};
          this.$http.post('Ucenter/consultAuth', param).then(response => {
            if( response.data.retcode === 0 ){
              this.getmine();
              // this.modalClose();
            }else{
              this.$message.error( response.data.errmsg );
            }
            this.loginnings = false;
          }).catch(err => {
            if( err.response ) {
              switch( err.response.status ) {
                case 422:
                  this.$message.error( '验证码错误！' );
              }
            }
            this.loginnings = false;
          });
        }else{
          // console.log('22222')
        }
      });
    },
    getmine(){
      let mineURL = 'userinfo/mine';
      this.$http.get(mineURL).then((response) => {
        let data = response.data;
        if (data.retcode === $conf.RETCODE_OK) {
          // if (data.data.phone === null || data.data.phone === '') {
          //   this.$store.commit('changebindPhone', true)
          // }
          this.$store.commit('changeloginStatus', true);
          this.$store.commit('changeMineInfo', data.data);
          /* socket */
          if(window.socket){
              window.socket.close();
          }
          sockets(data.data.id);
          // this.modalClose(); //关闭登录框
          this.$store.commit('changeOutsideLoginStatus', {display: false,type:1});
        } else {
          console.log(data.errmsg);
        }
      }).catch(error => {
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    setTime(ref) {
      setTimeout(() => {
        if( this[ref].runtime <= 0 ){
          this[ref].starttime = false;
        }else{
          this[ref].runtime -= 1;
          this.setTime(ref);
        }
      }, 1000);
    },
    starttime(ref) {
      this[ref].starttime = true;
      this[ref].runtime = this[ref].againtime;
      this.setTime(ref);
    },
  },
  watch: {
    OutsideloginStatus: {
      deep: true,
      handler(v, ov) {
        // console.log(v, ov)
        this.outsideLoginModal = v.display;
      }
    },
    outsidePhone:{
      deep:true,
      handler(v,ov){
        if(this.noteform.account == ''){
          this.noteform.account = v;
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/consult/outsideLogin.vue